export const INVERT_FILTER = 'brightness(0) invert(1)';
